module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"buttons":{"add":"Add sales tax","edit":"Edit sales tax","create":"Create and add sales tax"},"errors":{"addSalesTax":"There was an error adding a sales tax rate.  Please try again.","editSalesTax":"There was an error editing the sales tax rate.  Please try again."}}}')
  delete Component.options._Ctor
}
